import { h } from "preact";
import "./amounteditor.scss";

export function AmountEditor(props: { value: number, onChange?: (value: number) => void }) {
    return (
        <div class="amounteditor">
            <input type="button" value="-" disabled={props.value <= 0} onClick={() => props.onChange?.(props.value - 1)} />
            <input type="number" value={props.value} onChange={(e) => props.onChange?.(parseInt(e.currentTarget.value))} />
            <input type="button" value="+" onClick={() => props.onChange?.(props.value + 1)} />
        </div>
    );
}
